import { render, staticRenderFns } from "./MFeedback.vue?vue&type=template&id=2a86623c&"
import script from "./MFeedback.vue?vue&type=script&lang=js&"
export * from "./MFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports